'use strict';

var NewExtractSchedulingSubpanelDirective = function NewExtractSchedulingSubpanelDirective() {
  return {
    restrict: 'E',
    replace: true,
    template: require('../templates/new-extract-scheduling-subpanel.html'),
    requires: '^rmDataExtractNewExtract'
  };
};
NewExtractSchedulingSubpanelDirective.$inject = [];
module.exports = NewExtractSchedulingSubpanelDirective;